import { ThunkType } from "../../../../core/store/reducers";
import { getInvoiceXml } from "../api/getInvoiceXml";
import fileDownload from "js-file-download";
import { setXmlInvoiceFetchState } from "../invoicesDataSlice";
import { InvoiceData } from "../types";

export const xmlInvoiceThunk = (invoice?: InvoiceData): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (
    store.data.auth.current.status !== "successful" ||
    !invoice ||
    !invoice.invId
  ) {
    return undefined;
  }

  //	const filename = `TradingOrder${order.side.trim().toUpperCase()}_${lan.trim().toUpperCase()}_${order.ordNo}.pdf`

  const lan = store.ux.localization.language;
  const filename = `XmlInvoice_${lan.trim().toUpperCase()}_${
    invoice.invNo
  }.xml`;
  const user = store.data.auth.current.user;
  dispatch(setXmlInvoiceFetchState({ type: "started" }));
  const invoicesXml = await dispatch(getInvoiceXml(user, invoice.invId));
  if (invoicesXml) {
    fileDownload(
      new Blob([invoicesXml as any], { type: "application/pdf" }),
      filename
    );
  }
  dispatch(setXmlInvoiceFetchState({ type: "not-started" }));
};
